import type { IndexedPublicPlanPrices } from '@/lib/public-plan-prices-snapshot';
import {
  formatPublicIncludedUnits,
  formatPublicPlanOverage,
  formatPublicPlanPrice,
} from '@/lib/public-plan-prices';
import type { PaidPlanSlug } from '@/lib/plan-change';

export type SelectablePlanSlug = PaidPlanSlug | 'hobby';

export interface PlanChoice {
  slug: SelectablePlanSlug;
  name: string;
  description: string;
  price: string;
  included: string;
  mode?: 'subscription' | 'setup';
  helper?: string;
}

export const PLAN_CHOICES: PlanChoice[] = [
  {
    slug: 'hobby',
    name: 'Хобби',
    description: '100 запросов • требуется проверка карты',
    price: '0 ₽ / мес.',
    included: 'Жесткий лимит 100 запросов • без перерасхода',
    helper: 'Списаний нет. Верификация карты защищает платформу от злоупотреблений.',
    mode: 'setup',
  },
  {
    slug: 'basic',
    name: 'Базовый',
    description: '5 000 запросов • включены JSON templates',
    price: '',
    included: '',
  },
  {
    slug: 'pro',
    name: 'Про',
    description: '50 000 запросов • приоритетная поддержка по электронной почте',
    price: '',
    included: '',
  },
];

export const PLAN_NAME_LOOKUP: Record<SelectablePlanSlug, string> = PLAN_CHOICES.reduce(
  (acc, plan) => {
    acc[plan.slug] = plan.name;
    return acc;
  },
  {} as Record<SelectablePlanSlug, string>,
);

export function normalizeBillingPlanSlug(value?: string | null): SelectablePlanSlug | null {
  if (!value) {
    return null;
  }
  const normalized = value.toLowerCase();
  if (normalized === 'hobby' || normalized === 'basic' || normalized === 'pro') {
    return normalized as SelectablePlanSlug;
  }
  return null;
}

export function isBillingPaidPlanSlug(value?: string | null): value is PaidPlanSlug {
  const normalized = normalizeBillingPlanSlug(value);
  return normalized === 'basic' || normalized === 'pro';
}

export function buildDisplayedPlanChoices(
  publicPlanPrices: IndexedPublicPlanPrices,
): PlanChoice[] {
  return PLAN_CHOICES.map((choice) => {
    if (!isBillingPaidPlanSlug(choice.slug)) {
      return choice;
    }

    const publicPrice = publicPlanPrices[choice.slug];
    return {
      ...choice,
      price: `${formatPublicPlanPrice(publicPrice)} / мес.`,
      included: `${formatPublicIncludedUnits(publicPrice.included_units)} • ${formatPublicPlanOverage(publicPrice)}`,
    };
  });
}
